import React from 'react'
import WrapperByRole, { WrapperByRoleProps } from '../components/Wrapper/WrapperByRole'

const ReferentWrapper: React.FC<WrapperByRoleProps> = (props) =>
  <WrapperByRole role='pedagogical-referent' {...props} />


export default ReferentWrapper